import { render, staticRenderFns } from "./AvenantTypeForm.vue?vue&type=template&id=fd0134e0&scoped=true"
import script from "./AvenantTypeForm.vue?vue&type=script&lang=ts"
export * from "./AvenantTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0134e0",
  null
  
)

export default component.exports